export default __webpack_public_path__ + "static/media/RegularPause.4fe1ed93.png";